import { render, staticRenderFns } from "./ExpensesInformation.vue?vue&type=template&id=2ecea44e&scoped=true&"
import script from "./ExpensesInformation.vue?vue&type=script&lang=js&"
export * from "./ExpensesInformation.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesInformation.vue?vue&type=style&index=0&id=2ecea44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecea44e",
  null
  
)

export default component.exports